import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { ScopeOfWorkV2Store } from '../stores/v2';

export const useScopeOfWorkV2Store = () => useContext<{
  scopeOfWorkV2Store: ScopeOfWorkV2Store
}>(StoreContext);
